function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_URL = '/prototype/accounting/accounts-receivable/transactions';

export default {
    data: function data() {
        return {
            headers: ['ID', { title: 'Date', filter: 'dateFull' }, 'Resident', 'Unit', 'Code', { title: 'Has Override', filter: 'convertBoolean' }, { title: 'Paid', filter: 'convertBoolean' }, { title: 'Amount', filter: 'toCurrency' }],
            fields: ['id', 'post_date', "resident_name", "unit_name", 'code.name', 'has_override', 'is_paid', 'true_amount'],
            items: [],
            loading: false
        };
    },
    created: function created() {
        var _this = this;

        Event.$on('remove-transaction', function (item, idx) {
            Event.$emit('confirm-delete', item, '/prototype/accounting/accounts-receivable/transactions/delete', 'delete-transaction');
        });

        Event.$on('delete-transaction', this.deleteTransaction);
        Event.$on('view-ar-transaction', this.viewARTransaction);
        Event.$on('add-new-charge', this.addNewCharge);
        Event.$on('add-new-resident-charge', this.addResidentCharge);

        Event.$on('refresh-ar-transactions', function () {
            var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var search = arguments[1];
            var sort = arguments[2];
            var order = arguments[3];
            var isDate = arguments[4];

            _this.load(offset, search, sort, order, isDate);
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('remove-transaction');
        Event.$off('delete-transaction');
        Event.$off('view-ar-transaction');
        Event.$off('add-new-charge');
        Event.$off('refresh-ar-transactions');
    },

    methods: {
        addNewCharge: function addNewCharge() {
            var chargeScope = { chargeScopeType: 'property', chargeScopeId: this.$store.state.selectedProperty };

            Event.$emit('show-gl-wizard', false, false, chargeScope);
        },
        addResidentCharge: function addResidentCharge() {
            var chargeScope = { chargeScopeType: 'resident', chargeScopeId: this.$store.state.selectedProperty };

            Event.$emit('show-gl-wizard', false, false, chargeScope);
        },
        deleteTransaction: function deleteTransaction(item) {
            var $el = this;
            var $idx = $el.items.findIndex(function (i) {
                return i.id === item.id;
            });
            $el.items.splice($idx, 1);
            this.$snotify.error('The transaction was removed.');
        },
        viewARTransaction: function viewARTransaction(item) {
            axios.post(BASE_URL + '/fetch', { id: item.id }).then(function (response) {
                Event.$emit('show-flyout', 'Transaction Details', '', 'ar-view-transaction', response.data);
            });
        },
        load: function load(offset) {
            var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var sort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
            var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'DESC';
            var isDate = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;


            Event.$emit('data-table-loading');

            var self = this;
            var data = {
                offset: offset,
                search: search,
                sort: sort,
                order: order,
                isDate: isDate
            };

            axios.post(BASE_URL + '/list', data).then(function (response) {

                offset !== 0 ? self.items = [].concat(_toConsumableArray(self.items), _toConsumableArray(response.data)) : self.items = response.data;

                self.items.map(function (item) {

                    if (item.ledger.resident) {
                        item['resident_name'] = item.ledger.resident.person.full_name;

                        if (item.ledger.resident.unit) {
                            item['unit_name'] = item.ledger.resident.unit.name;
                        }
                    }
                });

                Event.$emit('data-table-loaded');
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-receivable/transactions/TransactionList.vue
// module id = FehR
// module chunks = 0 1